import { VerificationType, VerificationContext } from '../../lib/types';
import { generateKeyPair } from './../keyPair';
import { nextKeyId, generateWellKnownDid } from './generate';
import { queryDidDocument } from './query';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const issueDID = /* @__PURE__ */ __name(async (didInput) => {
  const { wellKnownDid, did } = await queryDidDocument({
    domain: didInput?.domain
  }) ?? {};
  if (wellKnownDid && wellKnownDid.id !== did) {
    throw new Error("Input domain mismatch: " + wellKnownDid.id + " !== " + did);
  }
  const keyId = nextKeyId(wellKnownDid);
  const hasModernPublicKey = didInput.publicKeyMultibase;
  const hasLegacyPublicKey = didInput.publicKeyBase58;
  const userProvidedKeys = hasModernPublicKey || hasLegacyPublicKey;
  if (userProvidedKeys && !didInput.type) {
    throw new Error("Key pair type must be provided when supplying existing keys");
  }
  const generatedKeyPair = userProvidedKeys ? {
    ...didInput
  } : await generateKeyPair(didInput);
  let keyPairs;
  if (generatedKeyPair.type === VerificationType.Bls12381G2Key2020) {
    keyPairs = {
      id: `${did}#keys-${keyId}`,
      type: VerificationType.Bls12381G2Key2020,
      controller: did,
      seedBase58: generatedKeyPair?.seedBase58,
      privateKeyBase58: generatedKeyPair?.privateKeyBase58,
      publicKeyBase58: generatedKeyPair?.publicKeyBase58
    };
  } else if (generatedKeyPair.type === VerificationType.Multikey) {
    keyPairs = {
      "@context": VerificationContext[VerificationType.Multikey],
      id: `${did}#keys-${keyId}`,
      type: VerificationType.Multikey,
      controller: did,
      secretKeyMultibase: generatedKeyPair?.secretKeyMultibase,
      publicKeyMultibase: generatedKeyPair?.publicKeyMultibase,
      ...generatedKeyPair?.seedBase58 && {
        seedBase58: generatedKeyPair.seedBase58
      }
    };
  }
  const generatedWellKnownDid = generateWellKnownDid({
    wellKnown: wellKnownDid,
    newKeyPair: keyPairs
  });
  return {
    wellKnownDid: generatedWellKnownDid,
    didKeyPairs: keyPairs
  };
}, "issueDID");

export { issueDID };
